import { render, staticRenderFns } from "./CmpXMultiselect.vue?vue&type=template&id=3b96b932&scoped=true&"
import script from "./CmpXMultiselect.vue?vue&type=script&lang=js&"
export * from "./CmpXMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b96b932",
  null
  
)

export default component.exports